@if (links.length > 0 && translationEntryPoint) {
  <ul nz-menu nzMode="horizontal">
    @for (link of links; track link) {
      <li nz-menu-item nzMatchRouter [routerLink]="[link]">
        <a>{{ translationEntryPoint + replaceDashes(link) | translate }}</a>
      </li>
    }
  </ul>
}

